import React from 'react';

import classnames from 'classnames';
import { RESOURCES_URL } from 'global-constants';

import WithPush from 'shared/HOCs/WithPush';

import Loader from 'shared/components/Loader';
import Button from 'shared/components/Button';
import ResourceBox from 'shared/components/ResourceBox';

import styles from './styles.module.scss';

const LatestResources = ({ resources, push, isFetching, className }) => (
  <div className={classnames(styles.container, 'container', className)}>
    <div className={styles.title}>Content Library</div>
    <div className={classnames(styles.resources, 'remove-xs')}>
      {isFetching ? (
        <Loader className={styles.loader} />
      ) : (
        resources.map((resource, key) => (
          <ResourceBox
            key={key}
            resource={resource}
            showButton={false}
            imageSize={{
              width: 350,
              height: 165
            }}
          />
        ))
      )}
    </div>
    <div className={classnames(styles.resources, 'remove-sm-min')}>
      {resources.map((resource, key) => (
        <ResourceBox
          key={key}
          resource={resource}
          showButton={false}
          imageSize={{
            width: '100%',
            height: 165
          }}
        />
      ))}
    </div>
  </div>
);

export default WithPush(LatestResources);
